module.exports = __webpack_public_path__ + "static/media/greenTheme-girl.4780b58a.svg";